import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { noop } from 'lodash';
import { Button } from '@zocdoc/components/src/button';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Modal, ModalContent } from '@zocdoc/components/src/modal';
import { FontFamily } from '@zocdoc/components/src/typography';
import { LOCALIZED_STRINGS } from './constants';
import DesktopImage from './assets/check-insurance-desktop.svg';
import MobileImage from './assets/check-insurance-mobile.svg';

export class CheckInsuranceModalView extends React.Component {
    static propTypes = {
        onClickCancel: PropTypes.func.isRequired,
        onClickCheckMyInsurance: PropTypes.func.isRequired,
        providerName: PropTypes.string.isRequired,
        showModal: PropTypes.bool,
        trackClickCheckMyInsurance: PropTypes.func,
        trackClickCloseCheckInsuranceModal: PropTypes.func,
        trackShowCheckInsuranceModal: PropTypes.func,
    };

    static defaultProps = {
        showModal: false,
        trackClickCheckMyInsurance: noop,
        trackClickCloseCheckInsuranceModal: noop,
        trackShowCheckInsuranceModal: noop,
    };

    componentDidMount() {
        const { showModal, trackShowCheckInsuranceModal } = this.props;
        if (showModal) {
            trackShowCheckInsuranceModal();
        }
    }

    render() {
        const { showModal } = this.props;
        if (!showModal) {
            return null;
        }

        const { providerName } = this.props;
        const descriptionTextParam = { providerName };
        return (
            <StyledModal onClickCancel={this.handleClickCancel}>
                <TopImageDesktop
                    data-test="check-insurance-modal-top-image-desktop"
                    image={DesktopImage}
                />
                <TopImageMobile
                    data-test="check-insurance-modal-top-image-mobile"
                    image={MobileImage}
                />
                <Title data-test="check-insurance-modal-title">
                    <FormattedMessage {...LOCALIZED_STRINGS.CheckInsuranceModalTitle} />
                </Title>
                <Description data-test="check-insurance-modal-description">
                    <FormattedMessage
                        values={descriptionTextParam}
                        {...LOCALIZED_STRINGS.CheckInsuranceModalDescription}
                    />
                </Description>
                <CheckInsuranceButton
                    data-test="check-insurance-modal-button"
                    onClick={this.handleClickCheckMyInsurance}
                >
                    <CheckInsuranceButtonText data-test="check-insurance-modal-button-text">
                        <FormattedMessage {...LOCALIZED_STRINGS.CheckInsuranceButton} />
                    </CheckInsuranceButtonText>
                </CheckInsuranceButton>
            </StyledModal>
        );
    }

    handleClickCancel = () => {
        const { onClickCancel, trackClickCloseCheckInsuranceModal } = this.props;
        trackClickCloseCheckInsuranceModal();
        onClickCancel();
    }

    handleClickCheckMyInsurance = () => {
        const { onClickCheckMyInsurance, trackClickCheckMyInsurance } = this.props;
        trackClickCheckMyInsurance();
        onClickCheckMyInsurance();
    }
}

const StyledModal = styled(Modal)`
    ${ModalContent} {

        padding: 20px 18px 20px 18px;

        ${breakpoint.medium} {
            min-width: 500px;
            width: 508px;
            height: 341px;
            padding: 35px 40px 35px 40px;
        }
    }
`;

const TopImageDesktop = styled.div`
    height: 102px;
    width: 102px;
    background: url(${p => p.image}) center no-repeat;
    margin: auto;
    display: none;

    ${breakpoint.medium} {
        display: block;
    }
`;

const TopImageMobile = styled(TopImageDesktop)`
    height: 80px;
    width: 80px;
    display: block;

    ${breakpoint.medium} {
        display: none;
    }
`;

const Title = styled.div`
    font: 21px/1.33 ${FontFamily.SharpSansBold};
    text-align: center;
    margin-top: 23px;
    margin-bottom: 9px;

    ${breakpoint.medium} {
        font: 24px/1.25 ${FontFamily.SharpSansBold};
    }
`;

const Description = styled.div`
    font: 15px ${FontFamily.SharpSansMedium};
    text-align: center;
    margin-bottom: 20px;
`;

const CheckInsuranceButton = styled(Button)`
    display: block;
    margin: auto;
    width: 100%;
    height: 44px;

    ${breakpoint.medium} {
        width: 428px;
        height: 48px;
    }
`;

const CheckInsuranceButtonText = styled.div`
    font: 16px/1.5 ${FontFamily.SharpSansSemibold};
`;
